export default __webpack_public_path__ + "static/media/bank2.540217d7.png";